import "./HomeContact.css";
const HomeContact = () => {
    return (  
        <>
        <h1 className="heading">Contact Us</h1>
        <div className="contact-footer">
            <div className="cont-info">
                <div className="left">
                    <h2>Johannesburg, <i>South Africa</i></h2>
                    <p>Unit 58 Mulberry Lane, 22 Doncaster Rd <br />
                        New Market Plan, 1448
                    </p>
                    <br />
                    <h2>Mpumalanga, <i>South Africa</i></h2>
                    <p>408 Motlokoa St, Siyathemba 
                    <br />
                        Balfour, 2410
                    </p>
                    <br />
                    <h2>Gauteng, <i>South Africa</i></h2>
                    <p> 20 harteebees Ave, Alrapark
                    <br />
                        Nigel, 1496
                    </p>
                    <br />
                    <p>Email: <a href="mailto: admin@amahle-amashenge.co.za">admin@amahle-amashenge.co.za</a></p>
                </div>
                <div className="right">
                    <h3>Call Directly:</h3>
                    <br />
                    <h1><a href="tel:+27 67 272 0035">+27 67 162 5597 </a></h1>
                    <br />
                </div>
            </div>
            <div className="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3577.2918324712873!2d28.127469!3d-26.2846378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e951ab971ab5e7b%3A0x6046f365a5766717!2s22%20Doncaster%20Rd%2C%20Newmarket%20AH%2C%20Alberton%2C%201449!5e0!3m2!1sen!2sza!4v1698919900141!5m2!1sen!2sza" width="800" height="600" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="1"></iframe>
            </div>
        </div>
        </>
    );
}
 
export default HomeContact;